<template>

</template>

<script>

import ContingencyPlan from './views/plan/contingencyPlan.vue'
export default {
  name: 'app',
  components: {
   ContingencyPlan
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
*{
  margin: 0;
  padding: 0;
}
</style>
